import merge from 'lodash/merge';

export const webappRoutes = {
  HOMEPAGE: {
    INDEX: '/',
  },
  ACADEMIES: {
    ADMIN: {
      INDEX: '/spaces/admin/academies',
      CREATE: '/spaces/admin/academies/create',
      EDIT: '/spaces/admin/academies/:id',
    },
  },
  ACCOUNT: {
    INDEX: '/account',
    ACCOMODATIONS: '/account/accomodations',
    ACCOMODATIONS_FIELD: '/account/accomodations/:field',
    ADDRESS_CONTACT: '/account/address-contact',
    ADDRESS_CONTACT_FIELD: '/account/address-contact/:field',
    IDENTITY: '/account/identity',
    IDENTITY_FIELD: '/account/identity/:field',
    JOB_PREFERENCES: '/account/job-preferences',
    JOB_PREFERENCES_FIELD: '/account/job-preferences/:field',
    LANGUAGES: '/account/languages',
    LANGUAGES_FIELD: '/account/languages/:field',
    PRESENTATION: '/account/presentation',
    PRESENTATION_FIELD: '/account/presentation/:field',
    PROFESSIONAL_EXPERIENCES: '/account/professional-experiences',
    PROFESSIONAL_EXPERIENCES_FIELD: '/account/professional-experiences/:field',
    SITUATION: '/account/situation',
    SITUATION_FIELD: '/account/situation/:field',
    STATUSES_AND_ALLOWANCES: '/account/statuses-and-allowances',
    STATUSES_AND_ALLOWANCES_FIELD: '/account/statuses-and-allowances/:field',
    TRAINING_ACTIVITIES: '/account/training-activities',
    TRAINING_ACTIVITIES_FIELD: '/account/training-activities/:field',
  },
  ADMIN: {
    SUBSCRIPTIONS_UNENROLL: '/spaces/admin/subscriptions/:subscription_id/unenroll',
    ORGANIZATIONS: {
      INDEX: '/spaces/admin/organizations',
      CREATE: '/spaces/admin/organizations/create',
      EDIT: '/spaces/admin/organizations/:id',
      TEAMS: '/spaces/admin/organizations/:id/teams',
      CREATE_TEAM: '/spaces/admin/organizations/:id/teams/create',
    },
    STUDENTS: {
      SESSIONS_MENTORING_DETAILS: '/spaces/admin/students/:studentId/sessions/mentoring/:sessionId',
    },
  },
  APPLICATION: {
    INDEX: '/application',
    WELCOME: '/application/welcome',
    THANKS: '/applications/:id/thank-you',
  },
  JOB_APPLICATIONS: {
    INDEX: '/job-applications/:id',
  },
  APPRENTICESHIP: {
    INDEX: '/apprenticeship',
  },
  APPRENTICESHIP_ONBOARDING: {
    START: '/apprenticeship-candidate-onboarding/start',
    QUESTIONS: '/apprenticeship-candidate-onboarding/questions',
  },
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    REGISTER_EMAIL: '/register/email',
    CHECK_DETAILS: '/check-details',
  },
  BUSINESS: {
    INDEX: '/business',
    BOOST: '/business/boost',
    SPARK: '/business/spark',
    PIVOT: '/business/pivot',
    UPLIFT: '/business/uplift',
    CONTACT_CONFIRMATION: '/business/contact/confirmation',
  },
  CERTIFICATIONS: {
    ADMIN: {
      INDEX: '/spaces/admin/certifications',
      CHOOSE_TYPE: '/spaces/admin/certifications/choose-type',
      CREATE: '/spaces/admin/certifications/create',
      EDIT: '/spaces/admin/certifications/:id',
    },
  },
  CERTIFICATION_AUTHORITIES: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-authorities',
      CREATE: '/spaces/admin/certification-authorities/create',
      EDIT: '/spaces/admin/certification-authorities/:id',
    },
  },
  CERTIFICATION_BUSINESS_PARTNERS: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-business-partners',
      CREATE: '/spaces/admin/certification-business-partners/create',
      EDIT: '/spaces/admin/certification-business-partners/:id',
    },
  },
  CERTIFICATION_HOLDERS: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-holders',
      CREATE: '/spaces/admin/certification-holders/create',
      EDIT: '/spaces/admin/certification-holders/:id',
    },
  },
  CONTRACTUALIZATION: {
    INDEX: '/contractualization/:organizationId',
    FUNNEL: {
      INDEX: '/contractualization/:organizationId/:studentApplicationId',
      EMPLOYER_CONTACTS:
        '/contractualization/:organizationId/:studentApplicationId/employer-contacts',
      EMPLOYER_TUTORS: '/contractualization/:organizationId/:studentApplicationId/employer-tutors',
      EMPLOYER_CONTRACT:
        '/contractualization/:organizationId/:studentApplicationId/employer-contract',
      EMPLOYER_CALENDAR:
        '/contractualization/:organizationId/:studentApplicationId/employer-calendar',
      BILLING_INFO: '/contractualization/:organizationId/:studentApplicationId/billing-info',
      STUDENT_INFO: '/contractualization/:organizationId/:studentApplicationId/student-info',
      SUMMARY: '/contractualization/:organizationId/:studentApplicationId/summary',
    },
  },
  COMMUNITY_PATHS: {
    ADMIN: {
      TO_CREATE: '/spaces/admin/communities/paths-to-create',
      CREATED: '/spaces/admin/communities/paths-created',
      DISABLED: '/spaces/admin/communities/paths-disabled',
      CREATE: '/spaces/admin/communities/paths/:communityPathId/create',
      EDIT: '/spaces/admin/communities/paths/:communityPathId/edit',
    },
  },
  COURSES: {
    INDEX: '/courses',
  },
  PROFILE_COMPLETION: {
    INDEX: '/profile-completion',
    REVIEW: '/profile-completion/review',
    IMPORT_RESUME: '/profile-completion/import-resume',
  },
  SPACES: {
    STUDENT: {
      INDEX: '/spaces/student',
      DASHBOARD: '/spaces/student/dashboard',
      PATHS: '/spaces/student/paths',
      COURSES: '/spaces/student/courses',
      FOLLOWED_COURSES: '/spaces/student/courses/followed',
      COMPLETED_COURSES: '/spaces/student/courses/completed',
      USER_FOLLOWED_COURSES: '/users/:userId/spaces/student/courses/followed',
      USER_COMPLETED_COURSES: '/users/:userId/spaces/student/courses/completed',
      ENROLLMENT: '/spaces/student/enrollment',
      TRAINING_PLANS: '/spaces/student/training-plans',
      TRAINING_PLAN_MODULE: '/spaces/student/training-plans/:trainingPlanId/module/:moduleId',
      DOCUMENTS: '/spaces/student/documents',
      USER_DOCUMENTS: '/users/:userId/spaces/student/documents',
      USER_TRAINING_PLANS: '/users/:userId/spaces/student/training-plans',
      USER_TRAINING_PLAN_MODULE:
        '/users/:userId/spaces/student/training-plans/:trainingPlanId/module/:moduleId',
      SESSIONS: '/spaces/student/sessions',
      SESSIONS_MENTORING_DETAILS: '/spaces/student/sessions/mentoring/:sessionId',
      SESSIONS_PRESENTATION_DETAILS: '/spaces/student/sessions/presentation/:sessionId',
      PLAYLISTS: '/spaces/student/playlists',
      PLAYLIST: '/spaces/student/playlists/:playlistId',
      JOB_POSTINGS: '/spaces/student/employment/job-postings',
      JOB_POSTING: '/spaces/student/employment/job-postings/:jobPostingId',
      APPLY_JOB_POSTING: '/spaces/student/employment/job-postings/:jobPostingId/apply',
      JOB_APPLICATIONS: '/spaces/student/employment/job-applications',
      JOB_PREFERENCES: '/spaces/student/employment/preferences',
      AUTO_APPLY: '/spaces/student/employment/auto-apply',
    },
    MENTOR: {
      INDEX: '/spaces/mentor',
      SESSIONS: '/spaces/mentor/sessions',
      SESSIONS_BOOKED: '/spaces/mentor/booked-mentorship-sessions',
      SESSIONS_HISTORY: '/spaces/mentor/mentorship-sessions-history',
      STUDENTS: '/spaces/mentor/students',
      STUDENT_DETAILS: '/spaces/mentor/students/:studentId',
      CALENDAR: '/spaces/mentor/calendar',
      CALENDAR_EDIT: '/spaces/mentor/calendar/edit',
      PREFERENCES: '/spaces/mentor/preferences',
      PREFERENCES_INVOICING: '/spaces/mentor/preferences-invoicing',
      INVOICING: '/spaces/mentor/invoicing',
      SESSIONS_MENTORING_DETAILS: '/spaces/mentor/sessions/mentoring/:sessionId',
      SESSIONS_PRESENTATION_DETAILS: '/spaces/mentor/sessions/presentation/:sessionId',
      ADMIN_SESSIONS_PRESENTATION_DETAILS: '/spaces/mentor/sessions/admin/presentation/:sessionId',
      MENTORING_SESSIONS_NEW: '/spaces/mentor/sessions/new',
      DEFENSE_SESSIONS_NEW: '/spaces/mentor/defense-sessions/new',
    },
    WORKPLACE_ADVISOR: {
      INDEX: '/spaces/workplace-advisor',
      DETAIL: '/spaces/workplace-advisor/:studentId',
      PROJECT: '/spaces/workplace-advisor/:studentId/projects/:projectId',
      TRAINING_PLAN_MODULE:
        '/spaces/workplace-advisor/:studentId/training-plans/:trainingPlanId/module/:moduleId',
    },
  },
  END_TRAINING: {
    CONGRATULATIONS: '/end-training/congratulations',
    PROOF_OF_COMPLETION: '/end-training/proof-of-completion',
  },
  ENROLLMENT: {
    INFORMATION: {
      INDEX: '/enrollment/information',
      THANK_YOU: '/enrollment/information/thank-you',
    },
  },
  INVITATIONS: {
    INDEX: '/invitations',
    JOIN: '/invitations/:invitation_id/join',
    REDIRECT: '/invitations/redirect',
  },
  JOB_POSTINGS: {
    INDEX: '/job-postings',
    DETAILS: '/job-postings/:jobTypeOrJobId',
    TYPE_DOMAIN: '/job-postings/:jobType/:domain_slug',
    TYPE_DOMAIN_PATH: '/job-postings/:jobType/:domain_slug/:path_slug',
    TYPE_DOMAIN_PATH_LOCALISATION: '/job-postings/:jobType/:domain_slug/:path_slug/:localisation',
  },
  JURY_ASSESSMENTS: {
    INDEX: '/paths/:pathId/users/:userId/jury-assessments',
    SEE_ASSESSMENTS: '/jury-sessions/:id/assessments/:assessmentId',
  },
  JURY_SESSIONS: {
    ADMIN: {
      INDEX: '/spaces/admin/jury-sessions',
      CREATE: '/spaces/admin/jury-sessions/create',
      EDIT: '/spaces/admin/jury-sessions/:id',
      CREATE_STUDENT_CREDENTIAL: '/spaces/admin/jury-sessions/:id/student-credentials/create',
      CREATE_ASSESSMENTS: '/spaces/admin/jury-sessions/:id/assessments/create',
    },
  },
  MATCH_DECLARATIONS: {
    INDEX: '/match-declarations',
    EMPLOYER: '/match-declarations/employer',
    CANDIDATE: '/match-declarations/candidate',
  },
  MATCH_CONFIRMATION: '/match-confirmation',
  MY_ORGANIZATION: {
    INDEX: '/my-organization/:path',
    OVERVIEW: '/my-organization/overview',
    TALENTS: '/my-organization/talents',
    SHARE_CANDIDATE: '/my-organization/share-candidate',
    FOLLOW_TALENT_SHORTLIST: '/my-organization/talent-shortlists/followed/new/:shortlistId',
    JOB_POSTINGS_CREATE: '/my-organization/job-postings/create',
    RECRUITMENT: { INDEX: '/my-organization/recruitment' },
  },
  ORGANIZATIONS: {
    INDEX: '/organizations/:organizationId',
    ANALYTICS: '/organizations/:organizationId/analytics',
    ANALYTICS_COURSES: '/organizations/:organizationId/analytics/courses',
    ANALYTICS_TRAINING_PROGRAMS: '/organizations/:organizationId/analytics/training-programs',
    INVITATIONS: '/organizations/:organizationId/invitations',
    OVERVIEW: '/organizations/:organizationId/overview',
    SHARE_CANDIDATE: '/organizations/:organizationId/share-candidate',
    TALENTS: '/organizations/:organizationId/talents',
    TALENT_CONTACT: '/organizations/:organizationId/talents/:userId/contact',
    TALENT_DETAILS: '/organizations/:organizationId/talents/:userId',
    TALENT_SEARCH: '/organizations/:organizationId/talents/searches/:searchId',
    TALENT_SEARCHES: '/organizations/:organizationId/talents/searches',
    TEAMS: '/organizations/:organizationId/teams',
    TEAM_INDEX: '/organizations/:organizationId/teams/:teamId',
    TEAM_SETTINGS: '/organizations/:organizationId/teams/:teamId/settings',
    TEAM_USERS: '/organizations/:organizationId/teams/:teamId/users',
    TEAM_USER: '/organizations/:organizationId/teams/:teamId/users/:userId',
    TEAM_PENDING_INVITATIONS: '/organizations/:organizationId/teams/:teamId/invitations',
    TEAM_USER_INVITATIONS: '/organizations/:organizationId/teams/:teamId/users/invite',
    USERS: '/organizations/:organizationId/users',
    USER_EDIT: '/organizations/:organizationId/users/:userId',
    USER_INVITATIONS: '/organizations/:organizationId/users/invite',
    JOB_POSTINGS: '/organizations/:organizationId/job-postings',
    JOB_POSTINGS_CREATE: '/organizations/:organizationId/job-postings/create',
    JOB_POSTINGS_CREATE_PREVIEW: '/organizations/:organizationId/job-postings/create/preview',
    JOB_POSTINGS_DETAILS: '/organizations/:organizationId/job-postings/:jobPostingId',
    JOB_POSTINGS_APPLICATIONS:
      '/organizations/:organizationId/job-postings/:jobPostingId/applications',
    TALENT_SHORTLISTS: {
      INDEX: '/organizations/:organizationId/talent-shortlists',
      DETAILS: '/organizations/:organizationId/talent-shortlists/:shortlistId',
      FOLLOWED: '/organizations/:organizationId/talent-shortlists/followed/:shortlistId',
    },
    RECRUITMENT: {
      INDEX: '/organizations/:organizationId/recruitment',
    },
  },
  PARTNERS: {
    INDEX: '/partners',
    SPARK_APPLY: '/partners/:partner/apply/spark',
    APPLICATION_COMPLETE: '/partners/:partner/complete-application',
  },
  PATH: {
    OUTCOMES: '/paths/:pathId/student-outcomes',
    PROJECT: '/paths/:pathId/projects/:projectId/:page',
    PROJECT_HOMEPAGE: '/paths/:pathId/projects/:projectId',
  },

  PROFILE: {
    INDEX: '/profile',
    VIEW_AS: '/profile/view-as/:persona',
    VIEW_AS_EDIT: '/profile/view-as/:persona/:field',
    VIEW_AS_EDIT_SPECIFIC: '/profile/view-as/:persona/:field/:id',

    /**
     * Redirects temporarily to the user account
     */
    EDIT: '/profile/:field',
    EDIT_SPECIFIC: '/profile/:field/:id',
  },

  RESUME: {
    APPRENTICESHIP: '/resume/apprenticeship/:userId',
  },
  SEARCH: {
    INDEX: '/search',
  },
  SECURITY: {
    SET_NEW_PASSWORD: '/set-new-password',
    GENERATE_PASSWORD: '/generate-password',
    CONFIRM_PASSWORD: '/confirm-new-password/:userId',
  },
  STUDENT_APPLICATION: {
    QUESTION: '/student-applications/:id/:step/:questionId',
  },
  STUDENT_CREDENTIALS: {
    PARCHMENT: {
      DOWNLOAD: '/student-credentials/:credentialNumber/parchment',
    },
    ADMIN: {
      INDEX: '/spaces/admin/student-credentials',
      EDIT: '/spaces/admin/student-credentials/:id',
    },
  },
  SUBSCRIPTIONS: {
    UNENROLL: '/subscriptions/:subscription_id/unenroll',
    PATH_ID_ERROR: '/subscriptions/paths/:pathId/path-error',
  },
  PAYMENT: {
    INDEX: '/payment/:pathId',
  },
  SURVEYS: {
    CAREER: {
      INDEX: '/users/:userId/survey/career/path/:pathId',
      END: '/users/:userId/survey/career/path/:pathId/end',
      JOB_SEEKER: '/users/:userId/survey/career/path/:pathId/job-seeker',
      NO_ACTIVITY: '/users/:userId/survey/career/path/:pathId/no-activity',
      TRAINING: '/users/:userId/survey/career/path/:pathId/training',
      BUSINESS_OWNER: '/users/:userId/survey/career/path/:pathId/business-owner',
      EMPLOYEE_CONTRACT: '/users/:userId/survey/career/path/:pathId/employee/contract',
      EMPLOYEE_ENTERPRISE: '/users/:userId/survey/career/path/:pathId/employee/enterprise',
    },
  },
  TALENT_SUGGESTIONS: {
    INDEX: '/talent-suggestions/:uuid',
    PRESELECTION: '/talent-suggestions/:uuid/preselections',
    PRESELECTION_CONFIRM: '/talent-suggestions/:uuid/preselections/confirm',
  },
  TALENTS: {
    LIST: '/talents',
    DETAILS: '/talents/:userId',
    SEARCH: '/talents/searches/:searchId',
  },
  TEAMS: {
    ANALYTICS: '/teams/:teamId/analytics',
    ANALYTICS_COURSES: '/teams/:teamId/analytics/courses',
    INVITATIONS: '/teams/:teamId/invitations',
    PLAYLISTS: '/teams/:teamId/playlists',
    PLAYLISTS_NEW: '/teams/:teamId/playlists/new',
    PLAYLIST_INDEX: '/teams/:teamId/playlists/:playlistId',
    PLAYLIST_USERS: '/teams/:teamId/playlists/:playlistId/users',
    PLAYLIST_USERS_ADD: '/teams/:teamId/playlists/:playlistId/users/add',
    PLAYLIST_COURSES: '/teams/:teamId/playlists/:playlistId/courses',
    PLAYLIST_COURSES_EDIT: '/teams/:teamId/playlists/:playlistId/courses/edit',
    SHOW: '/teams/:teamSlug',
    USERS: '/teams/:teamId/users',
    USER: '/teams/:teamId/users/:userId',
    ANALYTICS_TRAINING_PROGRAMS: '/teams/:teamId/analytics/training-programs',
    SETTINGS: '/teams/:teamId/settings',
    USER_INVITATIONS: '/teams/:teamId/users/invite',
    TALENTS: '/teams/:teamId/talents',
    TALENT_DETAILS: '/teams/:teamId/talents/:userId',
    TALENT_SEARCH: '/teams/:teamId/talents/searches/:searchId',
  },
  UK_APPRENTICESHIP: {
    INDEX: '/uk-apprenticeship',
  },
  UK_BUSINESS: {
    INDEX: '/uk-apprenticeship-for-business',
  },
  US_BUSINESS: {
    INDEX: '/us-apprenticeship-for-business',
  },
  VAP: {
    INDEX: '/vap/:config',
    WELCOME: '/vap/:config/welcome',
    THANKS: '/vap/:config/thank-you',
    MOTIVATIONS: '/vap/:config/motivations',
    EDUCATION: '/vap/:config/education',
    PROFESSIONAL_CAREER: '/vap/:config/professional-career',
    COMPETENCIES: '/vap/:config/competencies',
  },
  VIDEO_CONFERENCE: {
    MEET: '/video-conferences/:id/meet',
    CALL: '/video-conferences/:id/meet/call',
    END: '/video-conferences/:id/meet/end',
    SETTINGS: {
      INDEX: '/video-conferences/:id/meet/settings',
      CAMERA: '/video-conferences/:id/meet/settings/camera',
      MIC: '/video-conferences/:id/meet/settings/mic',
      SPEAKER: '/video-conferences/:id/meet/settings/speaker',
      END: '/video-conferences/:id/meet/settings/end',
    },
  },
  WELCOME: {
    INDEX: '/welcome',
    OFFER_DIPLOMA: '/welcome/offer-diploma',
    EMPLOYER_PHONE_NUMBER: '/welcome/employer-phone-number',
    SPARK: '/welcome/spark',
    ORGANIZATION: '/welcome/organization',
    RECRUITER: {
      INDEX: '/welcome/recruiter',
      INTENTION: '/welcome/recruiter/intention',
      FUNNEL: {
        REQUIREMENTS: '/welcome/recruiter/funnel/requirements',
        PREVIEW: '/welcome/recruiter/funnel/preview',
        INTENTIONS: '/welcome/recruiter/funnel/intentions',
      },
      PROFILE: '/welcome/recruiter/profile',
      PREVIEW: '/welcome/recruiter/preview',
    },
  },
};

export const nextJsRoutes = {
  ABOUT_US: {
    INDEX: '/about-us',
  },
  BUSINESS: {
    CONTACT: '/business/contact',
  },
  CLAIM_JOB: {
    INDEX: '/claim-job/:jobId',
  },

  WELCOME: {
    STUDENT_WELCOME: '/student-welcome',
  },
  ACCREDITATIONS: {
    WASC: '/accreditations/wasc',
  },
  CPF: {
    INDEX: '/cpf',
  },
  FUNDING: {
    INDEX: '/funding',
    EMPLOYEE: '/funding/employee',
    JOBSEEKER: '/funding/jobseeker',
    FREELANCER: '/funding/freelancer',
    STUDENT: '/funding/student',
  },
  PAGES: {
    DETAIL: '/p/:slug',
  },
  LEARNING_EXPERIENCE: {
    INDEX: '/learning-experience',
  },
  OFFERS: {
    INDEX: '/offers',
  },
  POLICIES: {
    TERMS_CONDITION: '/policies/terms-conditions',
    TERMS_SALES: '/policies/terms-of-sale',
    PRIVACY_POLICY: '/policies/privacy-policy',
    INTERNAL_STUDENTS_RULES: '/policies/internal-rules-for-students',
    LEGAL_INFORMATION: '/policies/legal-information',
  },
  SECURITY: {
    SECURITY_PAGE: '/security',
  },
  WASC: {
    INDEX: '/university-wasc',
  },
  WELCOME: {
    PATH_START: '/path-start',
    LEARNING_JOURNEY_INTRODUCTION: '/learning-journey-introduction',
  },
  END_TRAINING: {
    ABOUT_JURY: '/end-training/about-jury',
    ABOUT_COACHING: '/end-training/about-coaching',
  },
};

const legacyRoutes = {
  COURSES: {
    DETAIL: '/courses/:courseIdSlug',
    CHAPTERS: '/courses/:courseIdSlug/:chapterIdSlug',
    EXERCISES: '/courses/:courseIdSlug/exercises/:exerciseId',
  },
  SUBSCRIPTIONS: {
    SUBSCRIBE: '/subscriptions/subscribe/:pathSlug',
  },
  PATH: {
    INDEX: '/paths',
    DETAIL: '/paths/:pathId',
    SUPPORT_TAB: '/paths/:pathId/support',
    ADMIN: {
      CREATE: '/spaces/admin/paths/create',
    },
    SYLLABUS: '/paths/:pathSlug/pdf',
    APPRENTICESHIP_SYLLABUS: '/paths/:pathSlug/apprenticeshippdf',
  },
  ADMIN: {
    DASHBOARD: '/spaces/admin',
    INDEX: '/spaces/admin',
    SUBSCRIPTIONS_UNENROLL: '/spaces/admin/subscriptions/:subscription_id/unenroll',
    MENTOR: '/spaces/admin/mentors/:mentor_id',
    ORGANIZATIONS: {
      INDEX: '/spaces/admin/organizations',
      CREATE: '/spaces/admin/organizations/create',
      EDIT: '/spaces/admin/organizations/:id/edit',
      TEAMS: '/spaces/admin/organizations/:id/teams',
      CREATE_TEAM: '/spaces/admin/organizations/:id/teams/create',
      JOB_POSTINGS: '/spaces/admin/organizations/:id/job-postings',
      TALENT_SHORTLISTS: '/spaces/admin/organizations/:id/talent-shortlists',
    },
    PROJECTS: {
      INDEX: '/spaces/admin/project-versions',
      VIEW: '/spaces/admin/project-versions/:id/view',
      CREATE: '/spaces/admin/project-versions/create',
    },
    USERS: {
      PREMIUM: '/spaces/admin/users/:userId/premium',
    },
    STUDENTS: {
      INDEX: '/spaces/admin/students',
      DASHBOARD: '/spaces/admin/students/:studentId',
      EDIT: '/spaces/admin/students/:studentId/edit',
      PROJECT_EVALUATION:
        '/spaces/admin/students/:studentId/projects/:projectId/project-evaluation',
      PROJECT: '/spaces/admin/students/:studentId/projects/:projectId/:page',
      PATH_PROJECT: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId/:page',
      SESSIONS_MENTORING_DETAILS: '/spaces/admin/students/:studentId/sessions/mentoring/:sessionId',
      PATH_PROJECT_HOMEPAGE: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId',
      PROJECT_HOMEPAGE: '/spaces/admin/students/:studentId/projects/:projectId',
      TRAINING_PLAN_MODULE:
        '/spaces/admin/students/:studentId/training-plans/:trainingPlanId/module/:moduleId',
      TRAINING_PLAN: '/spaces/admin/students/:studentId/training-plans/:trainingPlanId',
    },
  },
  USER: {
    INDEX: '/users/:userId',
    PROJECT: '/users/:userId/projects/:projectId/:page', // Mentor view with student context (legacy)
    PROJECT_HOMEPAGE: '/users/:userId/projects/:projectId', // Mentor view with student context (legacy)
    PROJECT_EVALUATION: '/users/:userId/projects/:projectId/project-evaluation',
    PATH_PROJECT: '/users/:userId/paths/:pathId/projects/:projectId/:page', // Mentor view with student context
    PATH_PROJECT_HOMEPAGE: '/users/:userId/paths/:pathId/projects/:projectId', // Mentor view with student context
    PATH_PROOF_OF_COMPLETION_DOWNLOAD: `/users/:userId/paths/:pathId/proof-of-completion`,
  },
  PROJECT: {
    INDEX: '/projects/:projectId',
    PAGE: '/projects/:projectId/:page',
    HOMEPAGE: '/projects/:projectId',
    EVALUATION: '/projects/:projectId/project-evaluation',
    ADMIN: {
      INDEX: '/spaces/admin/projects',
      CREATE: '/spaces/admin/projects/create',
      OVERVIEW_EDIT: '/spaces/admin/projects/:projectId/overview',
      CONTENT_EDIT: '/spaces/admin/projects/:projectId/content',
      MENTOR_GUIDE_EDIT: '/spaces/admin/projects/:projectId/mentor-guide',
      EVALUATION_EDIT: '/spaces/admin/projects/:projectId/evaluation',
      EXTERNAL_RESOURCES: '/spaces/admin/projects/:projectId/external-resources',
      EXTERNAL_RESOURCES_CREATE: '/spaces/admin/projects/:projectId/external-resources/create',
      EXTERNAL_RESOURCES_EDIT:
        '/spaces/admin/projects/:projectId/external-resources/:externalResourceId',
      SECTIONS: '/spaces/admin/projects/:projectId/sections',
      SECTION_CREATE: '/spaces/admin/projects/:projectId/sections/create',
      SECTION_EDIT: '/spaces/admin/projects/:projectId/sections/:sectionId',
      MILESTONE_CREATE: '/spaces/admin/projects/:projectId/sections/:sectionId/milestones/create',
      MILESTONE_EDIT:
        '/spaces/admin/projects/:projectId/sections/:sectionId/milestones/:milestoneId',
      STUDENT: {
        INDEX: '/spaces/admin/students/:studentId/projects/:projectId',
        PATH: {
          INDEX: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId',
        },
      },
    },
    USER: {
      INDEX: '/users/:userId/projects/:projectId',
      PATH: {
        INDEX: '/users/:userId/paths/:pathId/projects/:projectId',
      },
    },
    PATH: {
      INDEX: '/paths/:pathId/projects/:projectId',
    },
  },
  MEMBERS: {
    SHOW: '/members/:id',
    PARAMETERS: '/members/:id/parameters',
    EDIT: '/members/:id/edit',
  },
  MENTORS: {
    EDIT: '/mentors/:mentorId/edit',
  },

  CERTIFICATE_SIGNATORIES: {
    ADMIN: {
      CREATE: '/spaces/admin/certificate-signatories/new',
    },
  },
};

const routes = merge({}, webappRoutes, nextJsRoutes, legacyRoutes);

export default routes;
